import React from 'react';
import { mockChargingStations } from '../../../mocks/mockChargers';
import { mockPlazaDetails } from '../../../mocks/mockPlazaDetails';
import './_styles.scss';
import { Dialog } from '../../../../../common/components/Dialog/Dialog';
import Button from '../../../../../common/components/Button/Button';
import StatusBadge from '../../components/StatusBadge/StatusBadge';

const PlazaDetailsDialog = ({ open, onClose, plazaId = null, plazaName = null, edgeControllerId = null }) => {
  if (!plazaId) return null;

  const plazaDetails = mockPlazaDetails[plazaId] || {};
  const chargingStations = mockChargingStations[plazaId] || [];

  const getStatusClassName = (status) => {
    const statusMap = {
      NOT_CONNECTED: 'status-available',
      CONNECTED_CHARGING: 'status-charging',
      FAULTED: 'status-faulted',
      CONNECTED_NOT_CHARGING: 'status-available',
      UNKNOWN: 'status-unknown',
      RESERVED_CABLE_DISCONNECTED: 'status-available',
    };
    return statusMap[status] || 'status-unknown';
  };

  const getStatusLabel = (status) => {
    const labelMap = {
      NOT_CONNECTED: 'Cable Disconnected',
      CONNECTED_CHARGING: 'Charging',
      FAULTED: 'Faulted',
      CONNECTED_NOT_CHARGING: 'Cable Connected, Not Charging',
      UNKNOWN: 'Unknown',
      RESERVED_CABLE_DISCONNECTED: 'Cable Disconnected, Reserved',
    };
    return labelMap[status] || status;
  };

  const actions = [
    <Button key="close" onClick={onClose} color="secondary">
      Close
    </Button>,
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={`Plaza Details: ${plazaName}`}
      maxWidth="md"
      fullWidth
      actions={actions}
      className="plaza-details-dialog"
    >
      <div className="plaza-details-content">
        <div className="plaza-info-section">
          <h3>Plaza Information</h3>
          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">Address:</span>
              <span className="info-value">{plazaDetails.address || 'N/A'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Total Chargers:</span>
              <span className="info-value">{plazaDetails.totalChargers || 0}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Available Chargers:</span>
              <span className="info-value">{plazaDetails.availableChargers || 0}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Plaza Algorithm:</span>
              <span className="info-value">{plazaDetails.algorithm || 'N/A'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Edge Controller:</span>
              <span className="info-value">{edgeControllerId}</span>
            </div>
          </div>
        </div>

        <div className="charging-stations-section">
          <h3>Charging Stations Managed by this Edge Controller</h3>
          {chargingStations.length > 0 ? (
            <div className="charging-stations-table">
              <table>
                <thead>
                  <tr>
                    <th>Charger ID</th>
                    <th>Name</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {chargingStations.map((station) => (
                    <tr key={station.id}>
                      <td>{station.id}</td>
                      <td>{station.name}</td>
                      <td aria-label={`Status: ${getStatusLabel(station.status)}`}>
                        <StatusBadge status={getStatusLabel(station.status)} statusClassName={getStatusClassName(station.status)} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="no-stations-message">No charging stations assigned to this plaza.</p>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default PlazaDetailsDialog;
